import { MenuList } from '@mui/material';
import { FC } from 'react';

interface Props {
  className?: string;
  children: React.ReactNode;
}

export const QcsMenuList: FC<Props> = ({ className, children }) => {
  return <MenuList className={className}>{children}</MenuList>;
};
